module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hello3 grid h100"
  }, [_c('div', {
    staticClass: "grid login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid form"
  }, [(_vm.loginform && !_vm.formReset || _vm.signupform && !_vm.formReset) ? _c('h2', [_vm._v("Accedi a Ombrelleria")]) : _vm._e(), _vm._v(" "), (_vm.formReset) ? _c('h2', [_vm._v("Inserisci la tua email")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), (!_vm.formReset) ? _c('el-form', {
    ref: "formLogin",
    attrs: {
      "model": _vm.formel,
      "rules": _vm.rules,
      "status-icon": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.signup('formLogin')
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    ref: "emailinput",
    attrs: {
      "placeholder": "Indirizzo Email",
      "type": "text",
      "prefix-icon": "fas fa-user-circle",
      "name": "email"
    },
    model: {
      value: (_vm.formel.email),
      callback: function($$v) {
        _vm.$set(_vm.formel, "email", $$v)
      },
      expression: "formel.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "placeholder": "Password",
      "prefix-icon": "fas fa-key",
      "name": "password"
    },
    model: {
      value: (_vm.formel.password),
      callback: function($$v) {
        _vm.$set(_vm.formel, "password", $$v)
      },
      expression: "formel.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-blue block",
    on: {
      "click": function($event) {
        return _vm.signup('formLogin')
      }
    }
  }, [_vm._v("login")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-secondary block",
    on: {
      "click": function($event) {
        _vm.loginform = false, _vm.signupform = true, _vm.error.state = false
      }
    }
  }, [_vm._v("registrati")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-secondary block",
    on: {
      "click": function($event) {
        _vm.formReset = true, _vm.error.state = false
      }
    }
  }, [_vm._v("ho dimenticato la password")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formReset) ? _c('el-form', {
    ref: "formReset",
    attrs: {
      "model": _vm.formel,
      "rules": _vm.rules,
      "status-icon": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.passreset('formReset')
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    ref: "emailinput",
    attrs: {
      "placeholder": "Indirizzo Email",
      "type": "text",
      "prefix-icon": "fas fa-user-circle",
      "name": "email"
    },
    model: {
      value: (_vm.formel.email),
      callback: function($$v) {
        _vm.$set(_vm.formel, "email", $$v)
      },
      expression: "formel.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-blue block",
    on: {
      "click": function($event) {
        return _vm.passreset('formReset')
      }
    }
  }, [_vm._v("manda nuova password")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-secondary block",
    on: {
      "click": function($event) {
        _vm.loginform = false, _vm.signupform = true, _vm.error.state = false
      }
    }
  }, [_vm._v("registrati")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-secondary block",
    on: {
      "click": function($event) {
        _vm.formReset = false, _vm.error.state = false
      }
    }
  }, [_vm._v("torna alla login")])], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "intermed "
  }, [_c('transition', {
    attrs: {
      "name": "slide-login",
      "mode": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginform),
      expression: "loginform"
    }],
    staticClass: "login",
    class: {
      success: _vm.success.state, error: _vm.error.state
    }
  }, [_c('h1', [_vm._v("Bentornato")]), _vm._v(" "), (_vm.error.state) ? _c('p', [_vm._v(_vm._s(_vm.error.message))]) : _vm._e(), _vm._v(" "), (_vm.success.state) ? _c('p', [_vm._v(_vm._s(_vm.success.message))]) : _vm._e()])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-signup",
      "mode": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.signupform),
      expression: "signupform"
    }],
    staticClass: "signup",
    class: {
      success: _vm.success.state, error: _vm.error.state
    }
  }, [_c('h1', [_vm._v("Benvenuto")]), _vm._v(" "), (_vm.error.state) ? _c('p', [_vm._v(_vm._s(_vm.error.message))]) : _vm._e(), _vm._v(" "), (_vm.success.state) ? _c('p', [_vm._v(_vm._s(_vm.success.message))]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "grid signup"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid form"
  }, [_c('h2', [_vm._v("Registrati a Ombrelleria")]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', {
    ref: "formsignup",
    attrs: {
      "model": _vm.formel,
      "rules": _vm.rules,
      "status-icon": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.signup('formsignup')
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Indirizzo Email",
      "type": "text",
      "prefix-icon": "fas fa-user-circle",
      "name": "email"
    },
    model: {
      value: (_vm.formel.email),
      callback: function($$v) {
        _vm.$set(_vm.formel, "email", $$v)
      },
      expression: "formel.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "placeholder": "Password",
      "prefix-icon": "fas fa-key",
      "name": "password"
    },
    model: {
      value: (_vm.formel.password),
      callback: function($$v) {
        _vm.$set(_vm.formel, "password", $$v)
      },
      expression: "formel.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-blue block",
    on: {
      "click": function($event) {
        return _vm.signup('formsignup')
      }
    }
  }, [_vm._v("Registrati")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-secondary block",
    on: {
      "click": function($event) {
        _vm.loginform = true, _vm.signupform = false, _vm.formReset = false, _vm.error.state = false
      }
    }
  }, [_vm._v("vai alla login")])], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo-alpha.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo-alpha.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b8ecaca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 639
// module chunks = 1